import { Util } from '@libs/utilities/util';

import { ActionsPipeHelper } from './processor-pipes/action-pipe.helper';
import { GroupPipeHelper } from './processor-pipes/group-pipe.helper';
import { OutputFormatPipeHelper } from './processor-pipes/output-format-pipe.helper';
import { SortingPipeHelper } from './processor-pipes/sorting-pipe.helper';
import { TextFormatPipeHelper } from './processor-pipes/text-format-pipe.helper';
import { IProcessedKeywords, IProcessingOptions } from './kw-workbench.interface';


/**------------------------------------------------------
 * Processing the Keywords
 */
export class KeywordWorkbench {

	constructor(
		private actionsPipeHelper		: ActionsPipeHelper,
		private groupPipeHelper			: GroupPipeHelper,
		private outputFormatPipeHelper	: OutputFormatPipeHelper,
		private sortingPipeHelper		: SortingPipeHelper,
		private textFormatPipeHelper	: TextFormatPipeHelper
	) {}


	/**------------------------------------------------------
	 * Keywords / Text Count Helpers
	 */
	getCharCount(text: string): number {
		return text.length;
	}
	getWordCount(text: string): number {
		return Util.Keywords.getWordsFromText(text).length;
	}
	getKeywordCount(text: string): number {
		return Util.Keywords.getKeywordsFromText(text, /(?:,)+/).length;
	}


	/**------------------------------------------------------
	 * Process keywords
	 */
	processKeywords(text: string, options: IProcessingOptions): IProcessedKeywords {

		//0 - extract the words / phrases from the text
		if (Util.String.isEmpty(text)) throw new Error(`KeywordProcessorService => processKeywords => FATAL ERROR: the text of "${text}" is empty`);

		//1 - process all piped operations
		const keywordsFromText: string[] = Util.Keywords.getKeywordsFromText(text, /(?:,)+/);
		const mappedKeywords  : string[] = Util.Pipeline.pipe(keywordsFromText,
			(keywords: string[]) => this.actionsPipeHelper.processActions(keywords, options.actions),
			(keywords: string[]) => this.textFormatPipeHelper.processTextFormatting(keywords, options.textFormat),
			(keywords: string[]) => this.sortingPipeHelper.processSorting(keywords, text, options.sorting)
		);

		//2 - process grouping & format as a single text
		const groupedKeywords: string[][] = this.groupPipeHelper.processGrouping(mappedKeywords, options);
		const processedText  : string	  = this.outputFormatPipeHelper.processOutputFormatting(groupedKeywords, options.outputFormat);

		//3 - return the processed keywords
		const processedKeywords: IProcessedKeywords = {
			keywords		: groupedKeywords,
			formattedText 	: processedText
		};
		return processedKeywords;
	}
}
